var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';

var IonPage = function IonPage(_a) {
  var children = _a.children,
      forwardedRef = _a.forwardedRef,
      className = _a.className,
      props = __rest(_a, ["children", "forwardedRef", "className"]);

  return React.createElement("div", Object.assign({
    className: className ? "ion-page ".concat(className) : 'ion-page',
    ref: forwardedRef
  }, props), children);
};

function forwardRef(props, ref) {
  return React.createElement(IonPage, Object.assign({}, props, {
    forwardedRef: ref
  }));
}

forwardRef.displayName = 'IonPage';
export default React.forwardRef(forwardRef);